import { Box, Flex, IconButton, Tooltip, VStack, Text } from '@chakra-ui/react'
import { FaBars, FaSuitcase, FaMoneyBillWave, FaStream, FaBell } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

interface iProps {
  onCollapse: (newVal: boolean) => void
  selecionado: string
  isCollapsed: boolean
}

export const Sidebar: React.FC<iProps> = ({ onCollapse, selecionado, isCollapsed }) => {
  const nav = useNavigate()

  const menuItems = [
    // { label: 'Visão geral', icon: FaChartBar, href: '/Descritivo/Dashboard' },
    { label: 'Cargos', icon: FaSuitcase, href: '/Descritivo/Cargos' },
    { label: 'Salários', icon: FaMoneyBillWave, href: '/Descritivo/Salarios' },
    { label: 'Critérios', icon: FaStream, href: '/Descritivo/Criterios' },
    { label: 'Trilhas de carreira', icon: FaBell, href: '/Descritivo/Trilhas' }
  ]

  return (
    <Flex
      direction="column"
      bg="white"
      borderRight="1px solid var(--Azul)"
      borderTop="1px solid var(--Azul)"
      transition="width 0.3s"
      width={isCollapsed ? '60px' : '220px'}
      minHeight="100vh"
      height="100%"
      overflow="hidden"
    >
      <Flex justifyContent="center" py="1rem" gap={'1.25rem'} alignItems={'center'}>
        {!isCollapsed && <Text fontSize={'18px'} color={'var(--Azul)'} fontWeight={'700'}>Cargos e salários</Text>}
        <IconButton
          aria-label="Menu"
          icon={<FaBars />}
          variant="unstyled"
          color="var(--Azul)"
          fontSize="18px"
          display={'flex'}
          border={'1px solid var(--Azul)'}
          p={'0'}
          alignItems={'center'}
          transition={'.3s'}
          justifyContent={'center'}
          _hover={{ bg: 'var(--Azul)', color: '#fff' }}
          onClick={() => onCollapse(!isCollapsed)}
        />
      </Flex>

      <VStack spacing="1rem" align="stretch" px={isCollapsed ? '0.5rem' : '1rem'}>
        {menuItems.map((item) => (
          <Tooltip
            key={item.label}
            label={isCollapsed ? item.label : ''}
            placement="right"
            bg={'var(--Azul)'}
            color={'var(--c1)'}
            hasArrow
          >
            <Flex
              align="center"
              gap=".75rem"
              p=".5rem"
              borderRadius=".375rem"
              cursor="pointer"
              color={selecionado === item.label ? '#fff' : 'var(--Azul)'}
              bg={selecionado === item.label ? 'var(--Azul)' : '#fff'}
              _hover={{ bg: 'var(--Azul)', color: '#fff', borderLeft: '1px solid #00000030', borderBottom: '1px solid #00000030', boxShadow: 'var(--SombraBtns)' }}
              transition="background-color 0.3s"
              onClick={() => { nav(item.href) }}
            >
              <Box as={item.icon} fontSize="20px" />
              {!isCollapsed && (
                <Text fontSize="14px" fontWeight="500">
                  {item.label}
                </Text>
              )}
            </Flex>
          </Tooltip>
        ))}
      </VStack>
    </Flex>
  )
}
